import React , {  useState, createContext , useEffect } from 'react';
import { getDocs , collection , db   } from '../firebase';

export const AppContext = createContext();

export const AppProvider = (props) => {

    const [cartItems , setCartItems] = useState([]);
    const [priceItems , setPriceItems] = useState(0);
    const [watch3d , setWatch3d] = useState(false);
    const [indexSlide , setIndexSlide] = useState(1);
    const [locationName , setLocationName] = useState('');

    

    const [photographersArray , setPhotographersArray] = useState([]);
    const [hotelArray , setHotelArray] = useState([]);
    const [tourGuideArray , setTourGuideArray] = useState([]);

    const [retreivealMarker , setRetreivalMarker ] = useState({
        "name": "جبال فيفا",
         "category": "public_place",
         "stars": 4,
         "description" : "  تقع جبال فيفا المذهلة والتي تُعد أكثر الأماكن السياحية زيارة في المنطقة بجنوب السعودية شرق مدينة جيزان وهي من الأماكن السياحية المذهلة والشهيرة بالمناظر الطبيعية الخلابة."
     });

     useEffect(() => {

        const getSubPackagesData = async () => { 
           
            const querySnapshot = await getDocs(collection(db, "sub_packages"));
            const subPackagesData = querySnapshot.docs
            .map((doc) => ({ ...doc.data(), id: doc.id }));
              
           
      
            let photographers = subPackagesData.filter(function (item) {
              return item.service_type === 'photography';
          });
          setPhotographersArray(photographers);
      
            let hotels = subPackagesData.filter(function (item) {
              return item.service_type === 'hotel';
          });
      
          setHotelArray(hotels);
      
      
            let tour_guides = subPackagesData.filter(function (item) {
              return item.service_type === 'tour_guide';
          });
      
          setTourGuideArray(tour_guides);
      
      
         
           
           
          }
          getSubPackagesData();

     } , [])

   
   


    return (
            <AppContext.Provider value={{ 
                retrive: [retreivealMarker , setRetreivalMarker],
                carts: [cartItems , setCartItems] ,
                view: [watch3d , setWatch3d],
                slideIndex: [ indexSlide , setIndexSlide ],
                 price: [priceItems , setPriceItems],
                 photographers: [photographersArray],
                 location : [ locationName , setLocationName ],
                 hotels: [hotelArray],
                 tours: [tourGuideArray],
                  }}  >
                {props.children}
            </AppContext.Provider>
    )
}